import Button from "../../components/Common/Button";
import PdfViewer from "../../components/Common/PdfViewer";
import VideoPlayer from "../../components/Common/VideoPlayer";
import { IzobrazevanjeJavnoDetailType } from "../../types/Izobrazevanje/IzobrazevanjeJavnoDetailType";
import { useFetchIzobrazevanjeDetail } from "../izobrazevanje/IzobrazevanjeHooks";
import styled from "styled-components";

const StyledIzobrazevanjeDetail = styled.div`
    .javnoContent{
        margin-bottom:1rem;
    }
`

interface JavnoDetailArgs {
    back: () => void,
    izobrazevanjeId: number
}

const JavnoDetail = ({ back, izobrazevanjeId }: JavnoDetailArgs) => {
    //const { data: izobrazevanje, status, isSuccess } = useFetchIzobrazevanjeDetail<IzobrazevanjeJavnoDetailType>(izobrazevanjeId);
    const { data: izobrazevanje, status, isSuccess } = useFetchIzobrazevanjeDetail(izobrazevanjeId);

    return (
        <StyledIzobrazevanjeDetail>
            <Button startIcon="arrow_back_ios" onClick={back}>
                Nazaj na seznam
            </Button>
            {isSuccess && izobrazevanje &&
                <>
                    <h1>{`${izobrazevanje.naziv}`}</h1>
                    {izobrazevanje.opis != null && <p>{`${izobrazevanje.opis}`}</p>}
                    <p>Kategorija: <b>{`${izobrazevanje.izobrazevanjeTipNaziv}`}</b></p>
                    <div className="javnoContent">
                        {izobrazevanje.dokumentPredvajalnik === "pdf" &&
                            <PdfViewer pdfDocumentPath={izobrazevanje.dokumentPot} />
                        }
                        {izobrazevanje.dokumentPredvajalnik === "video" &&
                            <VideoPlayer videoDocumentPath={izobrazevanje.dokumentPot} />
                        }
                    </div>
                    <Button startIcon="arrow_back_ios" onClick={back}>
                        Nazaj na seznam
                    </Button>
                </>
            }
        </StyledIzobrazevanjeDetail>
    );
}

export default JavnoDetail;